/**
 * Énumérations du catalogue (épopée E09 — articles, référentiels ; E10 — blocs de texte).
 * Référence : document 04 § 5.4 (`items`, `text_blocks`) et document 09 (US-E09, US-E10).
 */
/** Nature d'un article : produit, service ou bloc de texte insérable en ligne. */
export const ITEM_KINDS = ['product', 'service', 'text_block'];
/** Familles de fichiers rattachables à un article. */
export const ITEM_DOCUMENT_KINDS = [
    'photo',
    'technical_document',
    'commercial_document',
    'supplier_condition',
];
/** Classement d'un bloc de texte réutilisable. */
export const TEXT_BLOCK_CATEGORIES = [
    'clause',
    'note',
    'standard_text',
    'condition',
    'mention_legale',
    'header',
    'footer',
];
/** Emplacement d'insertion d'un bloc dans un document. */
export const TEXT_BLOCK_PLACEMENTS = [
    'before_lines',
    'after_lines',
    'footer',
    'header',
    'per_line',
    'terms',
];
//# sourceMappingURL=catalog.enum.js.map